angular.module("rental")
    .controller('RentalAgreementEditController', function (toastr, modals, $scope, $rootScope, $uibModalInstance, RentalAgreement, RentalAgreementConst, data, RentalAgreementService, RentalResourceService) {
        this.RentalAgreementService = RentalAgreementService
        this.RentalResourceService = RentalResourceService
        this.$onInit = () => {
            this.item = data
            this.load()
        }
        this.load = () => {
            if (this.item.id !== null) {
                RentalAgreement.get({id: this.item.id}).$promise.then(result => this.item = result)
            }
        }
        this.cancel = () => $uibModalInstance.dismiss()
        this.save = () => {
            let promise
            if (this.item.id !== null) {
                promise = RentalAgreement.update(this.item).$promise
            } else {
                promise = RentalAgreement.save(this.item).$promise
            }
            return promise.then(result => {
                $rootScope.$broadcast(RentalAgreementConst.eventUpdate)
                $uibModalInstance.close(result)
                toastr.success("Zapisano")
            })
        }

        $scope.$on(RentalAgreementConst.eventUpdate, () => this.load())
    })
